import * as React from 'react'
import ScanForm from './ScanForm'
import { QueryClientProvider } from 'react-query'
import buildQueryClient from '../helpers/queryClient'
import useScanForm from '../../hooks/useScanForm'
import { areaToOption } from './ScanFormFields'

type ScanAppProps = {
  availableAreas: string[]
  availableMachines: { id: number; name: string }[]
}

export default function ScanApp(props: ScanAppProps) {
  const queryClient = buildQueryClient()
  const { availableAreas } = props
  const form = useScanForm({area: areaToOption(availableAreas[0])})

  return (
    <QueryClientProvider client={queryClient}>
      <div className="pt-3">
        <ScanForm form={form} {...props} />
      </div>
    </QueryClientProvider>
  )
}
